'use strict';

import acceptedCookiePolicy from "../../../../components/onetrust/cookiePolicy";

const EVENTS_KEY = 'coveoWebsite.resourceEventSubscriptions';
const FIRSTNAME_KEY = 'coveoWebsite.marketoFirstName';

const getSubscribedEvents = () => {
    const subscribedEvents = [];

    const storageValue = localStorage.getItem(EVENTS_KEY);

    if (storageValue) {
        try {
            subscribedEvents.push(...JSON.parse(localStorage.getItem(EVENTS_KEY)));
        } catch {
            console.info('Could not parse localStorage resourceEventSubscriptions');
        }
    }

    return subscribedEvents;
};

export const addToResourceEventSubscriptions = (url) => {
    acceptedCookiePolicy({
        ifTargetingCookies: () => {
            let subscribedEvents = getSubscribedEvents();

            subscribedEvents.push(url);
            subscribedEvents = [...new Set(subscribedEvents)];

            localStorage.setItem(EVENTS_KEY, JSON.stringify(subscribedEvents));
        }
    });
};

export const isPageInResourceEventSubscriptions = (url) => {
    return getSubscribedEvents().some((event) => event === url);
};

export const getLocalStorageMarketoFirstName = () => {
    return localStorage.getItem(FIRSTNAME_KEY);
};

export const updateLocalStorageMarketoFirstName = (firstName) => {
    localStorage.setItem(FIRSTNAME_KEY, firstName);
};